import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userEmailRequestBackend } from './user-email-request.backend';
import { userEmailRequestReducer } from './user-email-request.reducer';

@NgModule({
  imports: [
    BackendModule.forFeature('userEmailRequest', userEmailRequestBackend),
    StoreModule.forFeature('userEmailRequest', userEmailRequestReducer),
  ],
})
export class DatastoreUserEmailRequestModule {}
